<template>
  <div class="page-endPage">
    <div class="content-wrap" ref="contentBScrollWrap">
      <div class="endPage_box">
        <img src="../../assets/gift_btn.png" class="gift_btn" @click="toGift">
        <img src="../../assets/letter.png" class="letter" :class="letter_bank ? 'letter_bank' : ''" >
      </div>
      <div class="award_box" v-if="Lottery">
        <div class="award">
          <img src="../../assets/award_text.png" class="award_text">
          <img src="../../assets/award.png" class="award_img">
          <img src="../../assets/toLottery.png" class="toLottery" @click="toLottery">
        </div>
      </div>
      <share ref="share"></share>
      <follow ref="follow"></follow>
      <tipBox ref="tipBox" :tipStyle="showTipBox" :awardName="awardName"></tipBox>
    </div>
  </div>
</template>

<script>
import share from '../../components/share'
import tipBox from '../../components/tipBox'
import follow from '../../components/follow'
import { Toast } from 'vant'
export default {
  name: 'page-endPage',
  data () {
    return {
      showTipBox: null,
      awardName: '',
      letter_bank: false,
      Lottery: false,
      isLotterying: false
    }
  },
  components: { share, tipBox, follow },
  async created () {
  },
  async mounted () {
    // this.$refs.share.show()
    if (this.$store.state.overTime) {
      Toast('活动已结束')
    } else {
      this.$store.commit('setMusic', true) // 显示音乐播放按钮
      this.letter_bank = true
      this.isLottery()
      // this.$stat({ event: 'endPage_page' }) // 上报事件
    }
    this.setWxShare()
  },
  methods: {
    isLottery () {
      const timer = setTimeout(() => {
        if (this.$store.state.is_Lottery) { // 抽过奖
          console.log('抽过奖')
          this.showTipBox = 4
        } else { // 未抽奖
          this.Lottery = true
          // this.toLottery()
        }
        clearTimeout(timer)
      }, 1600)
    },
    async toLottery () {
      this.$stat({ event: 'to_lottery' }) // 上报事件
      if (this.isLotterying) {
        return
      }
      this.isLotterying = true
      try {
        const res = await this.$fetch.post('/lottery/lottery', { able_type: this.$store.state.actInfo.package_name })
        console.log(res)
        this.$store.commit('setLottery', 1)
        this.isLotterying = false
        if (res.data.status) {
          if (res.data.type === 3) { // 红包
            this.awardName = res.data.message
            this.showTipBox = 2
          } else {
            this.awardName = res.data.message
            this.showTipBox = 1
          }
        } else {
          this.showTipBox = 3
        }
      } catch (error) {
        this.isLotterying = false
        if (error.state === 403) {
          this.$refs.follow.show()
          this.toSendMsg()
        } else {
          Toast(error.response.data.message)
        }
        console.log('error', error)
      }
      this.Lottery = false
    },
    async toSendMsg () { // 发送验证
      try {
        const res = await this.$fetch.get('blessing-card/send-message')
        console.log(res)
      } catch (err) {
        console.log(err)
      }
    },
    toGift () {
      this.$router.push({ path: '/rule' })
    },
    toRead () {
      // this.Lottery = true
      this.$router.push({ path: '/sharePage' })
    }
  },
  destroy () {
    // clearInterval(this.heartTimer)
  }
}
</script>

<style lang="scss" scoped>
.page-endPage, .content-wrap{
  width: 100%;
  height: 100vh;
}
.endPage_box{
  position: relative;
  width: 100%;
  height: auto;
  min-height: 100%;
  background: url('../../assets/p2_bg2.png') 100% center no-repeat, linear-gradient(to bottom,#7498d0, #92b2d7);
  background-size: 100%;
  .gift_btn{
    width: 86px;
    height: auto;
    position: absolute;
    top: 40px;
    right: 150px;
  }
  .treeBox{
    position: absolute;
    width: 664px;
    height: 1026px;
    left: 42px;
    bottom: 0;
    .tree{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
    }
    .letter{
      position: absolute;
      width: 588px;
      height: 415px;
      top: 0px;
      left: 81px;
      // width: 226px;
      // height: 160px;
      // top: 447px;
      // left: 220px;
    }
    .click_tip{
      position: absolute;
      width: 232px;
      height: 84px;
      top: 555px;
      left: 399px;
      opacity: 0;
      animation: click_tip 0.9s 3.6s ease-in-out infinite;
    }
  }
  .people{
    position: absolute;
    width: 366px;
    height: auto;
    top: 163px;
    left: -370px;
    // left: 0;
  }
  .letter_bank{
    animation: letter_bank 1.5s .2s ease-in-out forwards;
  }
}
.award_box{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  .award{
    position: absolute;
    bottom: 50%;
    right: 50%;
    transform: translate(50%, 50%);
    width: 524px;
    height: auto;
    .award_text{
      display: block;
      margin:auto;
      width: 425px;
      height: auto;
      opacity: 0;
      animation: fadeUp .6s 1s forwards;
    }
    .award_img{
      display: block;
      margin-top: -30px;
      width: 100%;
      height: auto;
      animation: zoomAndshake 1s ease-in;
    }
    .toLottery{
      width: 396px;
      height: auto;
      display: block;
      margin:auto;
      opacity: 0;
      animation: fadeIn .6s 1s forwards;
    }
  }
}
@keyframes letter_bank {
  0%{
    opacity: 1;
    transform: translate(0, 0) scale(1);
  }
  80%{
    opacity: 1;
  }
  100%{
    opacity: 0;
    transform: translate(-10px, 360px) scale(0.4);
  }
}
@keyframes click_tip {
  0%{
    opacity: 0;
    transform: translate(0, 0);
  }
  60%{
    opacity: 1;
    transform: translate(-30px, -20px);
  }
  100%{
    opacity: 1;
    transform: translate(-30px, -20px);
  }
}
@keyframes zoomAndshake {
  0% {
    transform: scale(0.3);
  }
  70%{
    transform: scale(1);
  }
  79%{
    transform: translateX(-10px);
  }
  82%{
    transform: translateX(0);
  }
  85%{
    transform: translateX(10px);
  }
  88% {
    transform: translateX(0);
  }
  91%{
    transform: translateX(-10px);
  }
  94%{
    transform: translateX(0);
  }
  97%{
    transform: translateX(10px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes fadeUp {
  0%{
    opacity: 0;
    transform: translateY(160px);
  }
  100%{
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeIn {
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
</style>
